import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { SetCasualActiveTabs, setCasualFormUpdateActions } from "../../../Redux/Slice";

const CasualJobInfo = (props) => {
  const { propsID } = props
  const dispatch = useDispatch()
  const [jobInfoFormData, setJobInfoFormData] = useState({
    salary: "",
    site_id: "",
    designation_id: "",
    uniform_types: [],
    uniform_sizes: {},
  });

  const siteOptions = [
    { value: "site_1", label: "Site 1" },
    { value: "site_2", label: "Site 2" },
    { value: "site_3", label: "Site 3" },
  ];

  const designationOptions = [
    { value: "helper", label: "Helper" },
    { value: "supervisor", label: "Supervisor" },
    { value: "technician", label: "Technician" },
    { value: "operator", label: "Operator" },
  ];

  const uniformTypeOptions = [
    { value: "shirt_size", label: "Shirt" },
    { value: "pant_size", label: "Pant" },
    { value: "shoe_size", label: "Shoe" },
    { value: "apron_size", label: "Apron" },
    { value: "top_size", label: "Top" },
    { value: "salwar_size", label: "Salwar" },
    { value: "t_shirt_size", label: "T-Shirt" },
    { value: "chef_coat_size", label: "Chef Coat" },
    { value: "dupatta_size", label: "Dupatta" },
    { value: "saree_size", label: "Saree" },
    { value: "rain_coat_size", label: "Rain Coat" },
    { value: "safari_size", label: "Safari" },
    { value: "cargo_pant_size", label: "Cargo Pant" },
    { value: "boots_size", label: "Boots" },
    { value: "cap_count", label: "Cap" },
    { value: "belt_count", label: "Belt" },
    { value: "lanyard_count", label: "Lanyard" },
    { value: "whishel_count", label: "Whistle" },
    { value: "umbrella_count", label: "Umbrella" },
    { value: "torch_light_count", label: "Torch Light" },
    { value: "traffic_control_torch_light_count", label: "Traffic Control Torch Light" },
  ];

  const uniformConfig = {
    shirt_size: { type: "select", options: ["S", "M", "L", "XL", "XXL"] },
    pant_size: { type: "select", options: ["28", "30", "32", "34", "36", "38"] },
    shoe_size: { type: "select", options: ["6", "7", "8", "9", "10", "11", "12"] },
    apron_size: { type: "select", options: ["S", "M", "L", "XL", "XXL"] },
    top_size: { type: "select", options: ["S", "M", "L", "XL", "XXL"] },
    salwar_size: { type: "select", options: ["S", "M", "L", "XL", "XXL"] },
    t_shirt_size: { type: "select", options: ["S", "M", "L", "XL", "XXL"] },
    chef_coat_size: { type: "select", options: ["S", "M", "L", "XL", "XXL"] },
    dupatta_size: { type: "select", options: ["S", "M", "L", "XL", "XXL"] },
    saree_size: { type: "select", options: ["S", "M", "L", "XL", "XXL"] },
    rain_coat_size: { type: "select", options: ["S", "M", "L", "XL", "XXL"] },
    safari_size: { type: "select", options: ["S", "M", "L", "XL", "XXL"] },
    cargo_pant_size: { type: "select", options: ["28", "30", "32", "34", "36", "38"] },
    boots_size: { type: "select", options: ["6", "7", "8", "9", "10", "11", "12"] },
    cap_count: { type: "text" },
    belt_count: { type: "text" },
    lanyard_count: { type: "text" },
    whishel_count: { type: "text" },
    umbrella_count: { type: "text" },
    torch_light_count: { type: "text" },
    traffic_control_torch_light_count: { type: "text" },
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setJobInfoFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleUniformTypeChange = (selectedOptions) => {
    const values = (selectedOptions || []).map((option) => option.value);

    setJobInfoFormData((prevData) => {
      const nextUniformSizes = { ...prevData.uniform_sizes };
      values.forEach((key) => {
        if (!nextUniformSizes[key]) {
          nextUniformSizes[key] = "";
        }
      });
      Object.keys(nextUniformSizes).forEach((key) => {
        if (!values.includes(key)) {
          delete nextUniformSizes[key];
        }
      });
      return {
        ...prevData,
        uniform_types: selectedOptions || [],
        uniform_sizes: nextUniformSizes,
      };
    });
  };

  const handleUniformSizeChange = (field, value) => {
    setJobInfoFormData((prevData) => ({
      ...prevData,
      uniform_sizes: {
        ...prevData.uniform_sizes,
        [field]: value,
      },
    }));
  };

  const getUniformLabel = (field) => {
    const option = uniformTypeOptions.find((item) => item.value === field);
    return option ? option.label : field;
  };

  const state = useSelector((state) => state);

  console.log(jobInfoFormData, "asjdjkasdjkasjjkdas");

  useEffect(() => {
    if (state?.CasualApproveRequestDatas?.Inquriy) {
      const responseData = state?.CasualApproveRequestDatas?.Inquriy;
      const uniformTypeKeys = Object?.keys(responseData?.uniform_details || {});
      const selectedUniformTypes = (uniformTypeKeys || []).map((value) => {
        const option = uniformTypeOptions?.find((item) => item.value === value);
        return (
          option || {
            value,
            label: value
              .replace(/_/g, " ")
              .replace(/\b\w/g, (char) => char.toUpperCase()),
          }
        );
      });

      console.log(selectedUniformTypes, "hhfhhhhfhffhfgh");

      setJobInfoFormData({
        salary: responseData?.salary ?? "",
        site_id: responseData?.client_id ?? "",
        designation_id: responseData?.designation_id ?? "",
        uniform_sizes: responseData?.uniform_details || {},
        uniform_types: selectedUniformTypes,
      });
    }
  }, [state.CasualApproveRequestDatas.Inquriy]);
  const HandleSaveNext = () => {
    const payload = {
      id: propsID,
      data: {
        salary: jobInfoFormData.salary,
        client_id: jobInfoFormData.site_id?.value,
        designation_id: jobInfoFormData.designation_id?.value,
        uniform_details: jobInfoFormData.uniform_sizes
      },
      Functions: () => {
        dispatch(SetCasualActiveTabs(4))
      }
    }
    dispatch(setCasualFormUpdateActions(payload))
  }
  console.log(jobInfoFormData, "jobInfoFormData")

  return (
    <div>
      <div>
        <div className="BodyContent">
          <div className="card">
            <div className="card-body cards">
              <div className="UserPoup">
                <div className="BeforForms">
                  <div className="Form">
                    <div className="ModalHeader">
                      <div>
                        <span>Job Information</span>
                      </div>
                    </div>
                    <div className="Modal-Body ModalForms">
                      <div className="row align-items-start">
                        <div className="col-sm-3 mt-3">
                          <label htmlFor="salary" className="form-label">
                            Salary
                          </label>
                          <input
                            type="number"
                            className="form-control"
                            id="salary"
                            autoComplete="off"
                            name="salary"
                            value={jobInfoFormData.salary}
                            onChange={handleChange}
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label htmlFor="site_id" className="form-label">
                            Site Location
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="site_id"
                            name="site_id"
                            value={jobInfoFormData.site_id?.client_name}
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label
                            htmlFor="designation_id"
                            className="form-label"
                          >
                            Designation
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="designation_id"
                            name="designation_id"
                            value={jobInfoFormData.designation_id?.role}
                            readOnly
                          />
                        </div>

                        <div className="col-sm-3 mt-3">
                          <label htmlFor="uniform_types" className="form-label">
                            Uniform Type
                          </label>
                          <Select
                            id="uniform_types"
                            name="uniform_types"
                            options={uniformTypeOptions}
                            value={jobInfoFormData.uniform_types || []}
                            onChange={handleUniformTypeChange}
                            isMulti
                            closeMenuOnSelect={false}
                            classNamePrefix="react-select"
                          />
                        </div>
                      </div>

                      {jobInfoFormData.uniform_types.length > 0 && (
                        <div className="row align-items-start mt-3">
                          {jobInfoFormData.uniform_types.map((item) => {
                            const field = item.value;
                            const config = uniformConfig[field];
                            return (
                              <div className="col-sm-3 mt-3" key={field}>
                                <label
                                  htmlFor={`uniform_size_${field}`}
                                  className="form-label"
                                >
                                  {item.label}
                                </label>
                                {config?.type === "select" ? (
                                  <select
                                    id={`uniform_size_${field}`}
                                    className="form-control"
                                    value={
                                      jobInfoFormData.uniform_sizes[field] || ""
                                    }
                                    onChange={(e) =>
                                      handleUniformSizeChange(
                                        field,
                                        e.target.value,
                                      )
                                    }
                                  >
                                    <option value="">Select size</option>
                                    {config.options.map((size) => (
                                      <option key={size} value={size}>
                                        {size}
                                      </option>
                                    ))}
                                  </select>
                                ) : (
                                  <input
                                    type="text"
                                    id={`uniform_size_${field}`}
                                    className="form-control"
                                    autoComplete="off"
                                    value={
                                      jobInfoFormData.uniform_sizes[field] || ""
                                    }
                                    onChange={(e) =>
                                      handleUniformSizeChange(
                                        field,
                                        e.target.value,
                                      )
                                    }
                                  />
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}

                      <div
                        className="RoleButton"
                        style={{
                          display: "flex",
                          gap: "15px",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          padding: "15px 0 0",
                          marginTop: "20px",
                          marginBottom: "10px",
                        }}
                      >
                        {state.CasualApproveRequestDatas.Inquriy?.is_pending &&

                          <button
                            type="button"
                            className="btn ButtonCSS"
                            style={{
                              color: "#ffff",
                              background: "#234492",
                            }}
                            onClick={HandleSaveNext}
                          >
                            Save & Continue
                          </button>}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CasualJobInfo;
